import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Jalapeno Poppers',
  source: 'https://therecipecritic.com/jalapeno-poppers-recipe/',
  totalTime: time(0, 30),
  servings: 5,
  tags: { type: 'side' },
  ingredients: [
    { name: 'jalapenos', quantity: '10',
      note: 'large',
    },
    { name: 'cream cheese', quantity: '8', unit: 'oz',
      note: 'softened',
    },
    { name: 'garlic powder', quantity: '1/2', unit: 'tsp' },
    { name: 'salt', quantity: '1/2', unit: 'tsp' },
    { name: 'black pepper', quantity: '1/4', unit: 'tsp' },
    { name: 'cheddar cheese', quantity: '1 1/2', unit: 'cup',
      note: 'shredded',
    },
    { name: 'bacon', quantity: '1/2', unit: 'lb',
      note: 'cooked & crumbled',
    },
    { name: 'green onions', quantity: '1/4', unit: 'cup',
      note: 'sliced',
    },
  ],
  directions: [
    {
      title: 'Prep jalapenos',
      bullets: [
        "Slice each {jalapenos} in half lengthwise",
        "Remove seeds & veins",
      ],
    },
    {
      title: 'Mix filling & stuff',
      bullets: [
        "In medium bowl, combine {cream cheese}, {garlic powder}, {salt}, {black pepper}, {cheddar cheese}, {bacon} & {green onions} into homogenous mixture",
        "Spoon mixture evenly into jalapeno halves",
        "Place stuffed jalapenos on baking sheet",
      ],
    },
    {
      title: 'Bake',
      bullets: [
        "Preheat oven to {!400F}",
        "Bake 20 min until tender",
      ],
    },
  ],
};

export default recipe;
